import { AI_PLATFORM_NOWCODING, normalizeCatalogPlatformId } from '../constants/aiPlatforms'
import type { ImageGenParams } from '../types/timeline'

/** NowCoding gpt-image-2 上游白名单（与 platform-image-models.yaml allowed-option-keys 对齐） */
const GPT_IMAGE2_COMMON_KEYS = [
  'quality',
  'background',
  'moderation',
  'output_format',
  'output_compression',
] as const

const NOWCODING_ONLY_KEYS = ['thinking'] as const

function passthroughKeys(platformId: string): readonly string[] {
  const pid = normalizeCatalogPlatformId(platformId)
  if (pid === AI_PLATFORM_NOWCODING) {
    return [...NOWCODING_ONLY_KEYS, ...GPT_IMAGE2_COMMON_KEYS]
  }
  return []
}

export function isGptImage2ImagePlatform(platformId: string): boolean {
  return normalizeCatalogPlatformId(platformId) === AI_PLATFORM_NOWCODING
}

export function buildGptImage2ImageOptions(
  platformId: string,
  apiSize: string,
  extraParamValues: Record<string, string>,
): Record<string, unknown> {
  const n = Math.min(10, Math.max(1, parseInt(extraParamValues.n ?? '1', 10) || 1))
  const opts: Record<string, unknown> = { size: apiSize, n }
  for (const key of passthroughKeys(platformId)) {
    const v = extraParamValues[key]?.trim()
    if (v) opts[key] = v
  }
  return opts
}

/** 写入时间线 params 快照，供 meta 行展示 */
export function snapshotGptImage2DisplayParams(
  platformId: string,
  extraParamValues: Record<string, string>,
): Pick<
  ImageGenParams,
  | 'quality'
  | 'background'
  | 'moderation'
  | 'output_format'
  | 'output_compression'
  | 'thinking'
> {
  const out: Pick<
    ImageGenParams,
    | 'quality'
    | 'background'
    | 'moderation'
    | 'output_format'
    | 'output_compression'
    | 'thinking'
  > = {}
  for (const key of passthroughKeys(platformId)) {
    const v = extraParamValues[key]?.trim()
    if (!v) continue
    if (key === 'quality') out.quality = v
    else if (key === 'background') out.background = v
    else if (key === 'moderation') out.moderation = v
    else if (key === 'output_format') out.output_format = v
    else if (key === 'output_compression') out.output_compression = v
    else if (key === 'thinking') out.thinking = v
  }
  return out
}
